/**
 * Organization: Revzoom India Pvt Ltd.
 * User: om
 * Date: 29/12/16
 * Time: 1:49 PM
 *
 */

import _ from 'lodash';
//import IAuthenticator from "./IAuthenticator";
import HashMap from './HashMap';
//import HttpOperation from './HttpOperation';
//import HttpOperationPayload from './HttpOperationPayload';
import AuthenticationData from './AuthenticationData';
import ErrorId from './ErrorId';
import ConnectionUtil from '../util/session/ConnectionUtil';
import System from '../basic/System';
import { NULL_OAUTH_REALM } from '../auth/AuthMechanism';
import t from './../i18n/I18n';

export default class Authenticator {
  constructor() {
    this.id2FailedRequests = new HashMap();
    /**
     *
     * @type {Array<Function>}
     */
    this.onAuthFailureCallback = [];

    /**
     * @type {AuthRealm}
     * @public
     */
    this.authRealm = NULL_OAUTH_REALM;
  }

  get authenticationData() {
    return Authenticator.AUTH_DATA;
  }

  setOnAuthFailureCallback(callback) {
    if (!callback) {
      return;
    }
    const callbacks: Array<Function> = this.onAuthFailureCallback;
    const length = callbacks.length;
    for (let index = 0; index < length; index++) {
      if (callbacks[index] === callback) {
        return;
      }
    }
    callbacks.push(callback);
  }

  removeOnAuthFailureCallback(callback) {
    if (!callback) {
      return;
    }
    const callbacks: Array<Function> = this.onAuthFailureCallback;
    const length = callbacks.length;
    for (let index = 0; index < length; index++) {
      if (callbacks[index] === callback) {
        if (index == length - 1) {
          callbacks.pop();
        } else {
          callbacks.splice(index, 1);
        }
        return;
      }
    }
  }

  invokeOnAuthFailureCallback(errorId: ErrorId) {
    const callbacks: Array<Function> = this.onAuthFailureCallback;
    const length = callbacks.length;
    for (let index = 0; index < length; index++) {
      const callback: Function = callbacks[index];
      callback(errorId);
    }
  }

  /**
   * @return {Authenticator}
   */
  static getInstance() {
    if (!Authenticator.AUTHENTICATOR_INSTANCE) {
      Authenticator.AUTHENTICATOR_INSTANCE = new Authenticator();
    }

    return Authenticator.AUTHENTICATOR_INSTANCE;
  }

  /**
   *
   * @param httpOperation{HttpOperation}
   * @param keyValueData{Object}
   */
  modifyRequest(httpOperation, keyValueData) {
    //if (this.authenticationData.repoId) keyValueData['zm_repo_id'] = this.authenticationData.repoId;
    //if (this.authenticationData.serverUrl) keyValueData['zm_server'] = this.authenticationData.serverUrl;

    if (httpOperation.name === 'VABLogin') {
      keyValueData['zm_username'] = this.authenticationData.username;
      keyValueData['zm_password'] = this.authenticationData.password;
    }
    //else {
    //    keyValueData['zm_cookie'] = this.authenticationData.cookie;
    //  }
    if (this.linkLogin) {
      keyValueData['link_login'] = this.linkLogin;
    }
    keyValueData['zm_app_name'] = System.getAppName();

    //this.addBrowserUrlToRequest(keyValueData);
  }

  /****
   *
   * Appends the current browser url in request with param name browserUrl, param name comes from Connections.BROWSER_URL
   * Method appends the url iff vab.browser property is set to true, and that happens only in browser.
   * This append is required, because then preview server can switch the webmin url.
   *
   * @param keyValueData{Object}
   */
  addBrowserUrlToRequest(keyValueData) {
    keyValueData['browserUrl'] = ConnectionUtil.getPreviewServerUrl();
  }

  /**
   * @param httpOperation{HttpOperation}
   * @param payload{HttpOperationPayload}
   * @return {boolean}
   */
  canSend(httpOperation, payload) {
    const name = httpOperation.name;
    return (
      name === Authenticator.LOGIN_QUERY_NAME ||
      name === 'GetCredentialsVab' ||
      name === 'OAuthLogin' ||
      name === 'RequestOTPForLogin' ||
      name === 'SendVerificationLinkToUser' ||
      name === 'CreateUserFromWebClient' ||
      name === 'GetCollectionParameters' ||
      this.id2FailedRequests.size() === 0
    );
  }

  /**
   *
   * @param httpOperation{HttpOperation}
   * @param httpStatusCode{number}
   * @param data{*}
   * @return {ErrorId}
   */
  onAuthFailure(httpOperation, httpStatusCode, data) {
    const parsedError = this.parseError(data);
    const backendErrorKey = parsedError == null ? null : parsedError.key;
    const backendErrorDetails = parsedError == null ? null : parsedError.msg;
    const errorKey = this.getErrorKey(httpStatusCode);
    let errorId = null;
    if (errorKey != null) {
      const error = this.getError(httpStatusCode, backendErrorDetails);
      errorId = new ErrorId(httpStatusCode, error, errorKey, backendErrorDetails);
    } else if (backendErrorKey) {
      const error = t(backendErrorKey);
      if (error) {
        errorId = new ErrorId(httpStatusCode, error, backendErrorKey, backendErrorDetails);
      } else {
        errorId = new ErrorId(httpStatusCode, t('UNKNOWN_ERROR'), 'UNKNOWN_ERROR', backendErrorDetails);
      }
    }
    if (errorId != null) {
      //We don't store the login queries...
      if (!Authenticator.isLoginQuery(httpOperation) && !Authenticator.isGetCredentialsQuery(httpOperation)) {
        this.storeFailedRequest(httpOperation);
      }
      this.invokeOnAuthFailureCallback(errorId);
    }
    return errorId;
  }

  runAuthFailedRequests() {
    if (this.id2FailedRequests.size() > 0) {
      let hashMapIterator = this.id2FailedRequests.iterator();
      while (hashMapIterator.hasNext()) {
        let next = hashMapIterator.next();
        /**
         *
         * @type {HttpOperation}
         */
        let value = next.getValue();
        value.executePreviousPayload();
      }
    }
    this.id2FailedRequests.clear();
  }

  /**
   * @param httpOperation{HttpOperation}
   * @private
   */
  storeFailedRequest(httpOperation) {
    this.id2FailedRequests.put(httpOperation.requestId, httpOperation);
  }

  /**
   *
   * @param httpOperation{HttpOperation}
   * @return {boolean}
   * @public
   */
  static isLoginQuery(httpOperation) {
    return httpOperation.name === Authenticator.LOGIN_QUERY_NAME || httpOperation.name === 'OAuthLogin';
  }

  static isGetCredentialsQuery(httpOperation) {
    return httpOperation.name === Authenticator.GetCredentialsVab;
  }

  static isWhitelistedQuery(httpOperation) {
    return _.includes(Authenticator.WHITELIST_QUERY_NAMES, httpOperation.name);
  }

  /**
   * @return {number}
   */
  static AUTH_OK() {
    return 0;
  }

  /**
   * @return {number}
   */
  static NO_CREDENTIALS() {
    return 1;
  }

  /**
   * @return {number}
   */
  static AUTHC_ERROR() {
    return 2;
  }

  /**
   * @return {number}
   */
  static ZM_SERVER_NOT_RESPONDING() {
    return 3;
  }

  /**
   * @return {number}
   */
  static CONNECT_FAILED() {
    return 4;
  }

  /**
   * @return {number}
   */
  static AUTHZ_ERROR() {
    return 5;
  }

  /**
   * @return {number}
   */
  static ABORT_AUTHC_ERROR() {
    return 6;
  }

  /**
   * @return {number}
   */
  static ABORT_AUTHZ_ERROR() {
    return 9;
  }

  /**
   *
   * @param errorCode{number}
   * @param errorDetails{string}
   * @return {string|*}
   */
  getError(errorCode, errorDetails) {
    const errorCodeString = errorCode.toString();
    errorCode = parseInt(errorCodeString.charAt(errorCodeString.length - 1));
    switch (errorCode) {
      case Authenticator.AUTH_OK():
        return t('LOGIN.AUTH_OK');
      case Authenticator.AUTHC_ERROR():
        return t('LOGIN.AUTHC_ERROR', this.authenticationData.username);
      case Authenticator.NO_CREDENTIALS():
        return t('LOGIN.NO_CREDENTIALS');
      case Authenticator.ZM_SERVER_NOT_RESPONDING():
        return t('LOGIN.ZM_SERVER_NOT_RESPONDING');
      case Authenticator.CONNECT_FAILED():
        return t('LOGIN.CONNECT_FAILED');
      case Authenticator.AUTHZ_ERROR():
        return t('LOGIN.AUTHZ_ERROR', this.authenticationData.username);
      case Authenticator.ABORT_AUTHC_ERROR():
        return t('LOGIN.ABORT_AUTHC_ERROR');
      case Authenticator.ABORT_AUTHZ_ERROR():
        return t('LOGIN.ABORT_AUTHZ_ERROR', this.authenticationData.username);
      default:
        return null;
    }
  }

  /**
   *
   * @param errorCode{number}
   * @return {string|*}
   */
  getErrorKey(errorCode) {
    const errorCodeString = errorCode.toString();
    errorCode = parseInt(errorCodeString.charAt(errorCodeString.length - 1));
    switch (errorCode) {
      case Authenticator.AUTH_OK():
        return 'LOGIN.AUTH_OK';
      case Authenticator.AUTHC_ERROR():
        return 'LOGIN.AUTHC_ERROR';
      case Authenticator.NO_CREDENTIALS():
        return 'LOGIN.NO_CREDENTIALS';
      case Authenticator.ZM_SERVER_NOT_RESPONDING():
        return 'LOGIN.ZM_SERVER_NOT_RESPONDING';
      case Authenticator.CONNECT_FAILED():
        return 'LOGIN.CONNECT_FAILED';
      case Authenticator.AUTHZ_ERROR():
        return 'LOGIN.AUTHZ_ERROR';
      case Authenticator.ABORT_AUTHC_ERROR():
        return 'LOGIN.ABORT_AUTHC_ERROR';
      case Authenticator.ABORT_AUTHZ_ERROR():
        return 'LOGIN.ABORT_AUTHZ_ERROR';
      default:
        return null;
    }
  }

  /**
   *
   * @param errorStr{string}
   * @return {msg: string, key: string}
   */
  parseErrorString(errorStr: string) {
    let errMsg = null;
    if (errorStr) {
      const errorParts = errorStr.match('__ERROR_START__([A-Z][A-Z0-9_]*)__:__[0-9]+__:__(.*)__ERROR_END__');
      if (errorParts != null) {
        errMsg = { key: errorParts[1] === 'UNKNOWN' ? 'UNKNOWN_ERROR' : errorParts[1], msg: this.unescapeXMLEncoding(errorParts[2]) };
      }
    }
    return errMsg;
  }

  /**
   *
   * @param str{string}
   * @return {String}
   */
  unescapeXMLEncoding(str: string) {
    return !str ? str : String(str).replace(/&gt;/g, ">").replace(/&lt;/g, "<").replace(/&quot;/g, '"').replace(/&apos;/g, "'").replace(/&amp;/g, "&");
  }

  /**
   *
   * @param data{*}
   * @return {msg: string, key: string}
   */
  parseError(data) {
    let parsedError = null;
    if (data != null) {
      if (typeof data === 'string' || data instanceof String) {
        parsedError = this.parseErrorString(data);
      } else if (data.hasOwnProperty('errorMsg')) {
        parsedError = { key: data.hasOwnProperty('errorKey') ? data.errorKey : null, msg: data.errorMsg };
      } else if (data.hasOwnProperty('message')) {
        // Jetty's in-built JSON Error Handler output
        parsedError = this.parseErrorString(data.message);
      }
    }
    return parsedError;
  }

  /**
   * @type {AuthenticationData}
   */
  static AUTH_DATA = new AuthenticationData();

  static AUTHENTICATOR_INSTANCE: Authenticator;
}

/**
 *
 * @type {string}
 * @private
 */
Authenticator.LOGIN_QUERY_NAME = 'VABLogin';

/**
 * @private
 */
Authenticator.AUTHENTICATOR_INSTANCE = null;

Authenticator.WHITELIST_QUERY_NAMES = ['VABLogin', 'SendVerificationLinkToUser', 'CreateUserFromWebClient'];
